import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBtCqCLDvPoayE173gCcmp4_I7dbF0BbRI",
  authDomain: "emthany-3a65b.firebaseapp.com",
  projectId: "emthany-3a65b",
  storageBucket: "emthany-3a65b.firebasestorage.app",
  messagingSenderId: "753199921432",
  appId: "1:753199921432:web:045b4a08e21f323dc7866d",
  measurementId: "G-1S844QSJGW"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize messaging if browser supports it
let messaging = null;
try {
  if (typeof window !== 'undefined' && 'Notification' in window) {
    messaging = getMessaging(app);
  }
} catch (error) {
}

export const requestForToken = async () => {
  if (!messaging) return null;
  
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: 'BHCMXnNt0Cz5NfN9Q0_qBEB2jW_zV8DJPr1BnZxWbfGroqv_eMvdR1qQIOhf5U6FdXsEbYLukyDNuVqFAAL3AUI'
    });
    return currentToken || null;
  } catch (err) {
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }
    
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export default app; 